import groq from 'groq';

import { PLP_HREF } from '../common/plpHref';
import { PRODUCT_SLUG } from '../product';

export const PRODUCT_CAROUSEL = groq`
  title,
  productCollection -> {
    name,
    "products": products[].product -> { ${PRODUCT_SLUG} }
  },
  plpRef -> {
    ${PLP_HREF},
    label,
    category
  },
  "isSkincareCardVisible": coalesce(isSkincareCardVisible, false)
`;

export const PRODUCT_CAROUSEL_BLOCK = groq`
  _type == 'productCarousel' => {
    ${PRODUCT_CAROUSEL}
  }
`;
